import { useState } from "react";
import { faqItems } from "@/mocks/home";

const trustPoints = [
  { icon: "ri-shield-check-line", title: "资源维护常态化", desc: "定期清理失效入口，保证观赏与收藏的可达性。" },
  { icon: "ri-time-line", title: "更新节奏稳定", desc: "套图每日更新、视频按周上新，追更不迷路。" },
  { icon: "ri-sort-desc", title: "分类清晰可检索", desc: "按风格、季节与年份归档，快速定位所需内容。" },
];

export default function TrustFaq() {
  const [openId, setOpenId] = useState<string>(faqItems[0].id);

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-8">
        <div className="lg:col-span-2">
          <span className="text-primary-600 text-xs font-medium tracking-[0.24em] uppercase">
            Trust &amp; FAQ
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
            用起来更放心的几个理由
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2 leading-relaxed">
            站点围绕「好找、好看、好收藏」持续打磨，把资源的可达性与观赏体验放在第一位。
          </p>

          <div className="flex flex-col gap-3 mt-6">
            {trustPoints.map((point) => (
              <div
                key={point.title}
                className="flex items-start gap-4 bg-background-50 border border-background-200/80 rounded-lg p-4"
              >
                <span className="w-11 h-11 shrink-0 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${point.icon} text-xl`} />
                </span>
                <span className="flex flex-col">
                  <span className="font-heading font-bold text-foreground-950 text-base">
                    {point.title}
                  </span>
                  <span className="text-sm text-foreground-600 mt-1">{point.desc}</span>
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3 bg-background-100/70 rounded-lg border border-background-200/70 p-5 md:p-7">
          <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-5">
            常见问题解答
          </h3>
          <div className="flex flex-col gap-3">
            {faqItems.map((item) => {
              const open = openId === item.id;
              return (
                <div
                  key={item.id}
                  className={`rounded-lg border transition-colors ${
                    open
                      ? "bg-background-50 border-primary-300"
                      : "bg-background-50 border-background-200/80"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? "" : item.id)}
                    className="w-full flex items-center justify-between gap-4 text-left px-4 md:px-5 py-4 cursor-pointer"
                  >
                    <span className="font-medium text-foreground-950 text-sm md:text-base">
                      {item.q}
                    </span>
                    <i
                      className={`ri-add-line text-primary-500 text-lg shrink-0 transition-transform duration-300 ${
                        open ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  {open && (
                    <p className="px-4 md:px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}